import { SendToSelection } from "models/SendToSelection";
import { SendToTargetModel } from "models/SendToTargetModel";
import { createContext } from "react";

export interface SendToPanelContextProps {
  isOpen: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  isSubmitted: boolean;
  isForm: boolean;
  agendaItemId: number | null;
  results: SendToTargetModel[];
  getId: (item: SendToTargetModel) => number;

  isSubmitDisabled: boolean;
  openSendToPanel: (agendaItemId: number) => void;
  closeSendToPanel: () => void;
  getSelection: (targetId: number) => SendToSelection;
  onSelectItem: (item: SendToTargetModel) => void;
  onSetMeeting: (item: SendToTargetModel, meetingId: number) => void;
  submitSendToPanel: () => void;
}

export const SendToPanelContext = createContext({} as SendToPanelContextProps);
